import type Phaser from 'phaser';
import { h01Symbols } from '../../content/scenes/raadhustorvet';
import type { GameState } from '../../domain/types';

export class TownSquarePresentation {
  readonly #labels: Phaser.GameObjects.Text[];
  readonly #status: Phaser.GameObjects.Text;
  readonly #sack: Phaser.GameObjects.Image;

  constructor(scene: Phaser.Scene, reducedMotion: boolean) {
    this.#sack = scene.add
      .image(1635, 800, 'grain-sack-icon')
      .setDisplaySize(270, 310)
      .setDepth(17);
    this.#labels = h01Symbols.map((symbol) =>
      scene.add
        .text(symbol.x, 859, 'Vælg erhverv', {
          fontFamily: 'Arial, sans-serif',
          fontSize: '19px',
          color: '#fff1cc',
        })
        .setOrigin(0.5)
        .setDepth(18),
    );
    this.#status = scene.add
      .text(975, 969, '', {
        fontFamily: 'Arial, sans-serif',
        fontSize: '25px',
        color: '#fff1cc',
        backgroundColor: '#0b2433',
        padding: { x: 22, y: 14 },
      })
      .setOrigin(0.5)
      .setDepth(18);
    const light = scene.add.ellipse(1640, 540, 235, 120, 0xf5c45e, 0.08).setDepth(10);
    if (!reducedMotion)
      scene.tweens.add({
        targets: light,
        alpha: 0.16,
        duration: 2400,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut',
      });
  }

  refresh(state: Readonly<GameState>): void {
    let matched = 0;
    h01Symbols.forEach((symbol, index) => {
      const solved = state.flags['h01:' + symbol.id] === true;
      if (solved) matched++;
      this.#labels[index]
        ?.setText(solved ? symbol.trade + ' ✓' : 'Vælg erhverv')
        .setColor(solved ? '#8fe4c5' : '#fff1cc');
    });
    const collected = state.flags['h01:sackCollected'] === true;
    this.#sack.setVisible(!collected);
    this.#status.setText(
      collected
        ? 'Tillykke! Den tomme kornsæk er nu din.'
        : matched === 4
          ? 'Alle fire passer! Tag kornsækken ved boden.'
          : matched + ' af 4 erhverv fundet · Undersøg symbolkortene',
    );
  }
}
